module.exports = __webpack_public_path__ + "img/dfs-logo-black.b86dd557.svg";